export module Pagamentos {
	export interface Fornecedor {
		id: number
		fornecedor: string
		img: string
		valorPlano: number
		formaPagamento: Array<ITipoPagamento>
	}
	export interface ITipoPagamento {
		id: number
		tipo: number
		valor: number
		img: string
		formaPagamento: number
		nome: string
		parcelas: Array<Parcelas>
		descricao: string
		qtdParcela: number
		textoParcela: string
	}

	export class TipoPagamento implements ITipoPagamento {
		id: number = 0
		tipo: number = 0
		valor: number = 0
		img: string = ''
		formaPagamento: number = 0
		nome: string = ''
		parcelas!: Array<Parcelas>
		descricao: string = ''
		qtdParcela: number = 0
		textoParcela: string = ''
	}

	export interface IParcelas {
		nomeCondicaoPagamento: string
		valorParcela: number
		quantidadeParcela: number
		texto: string
		formaPagamento: number
		idPagamento: number
		colorTexto: string
		codigoExterno: number | undefined
	}

	export class Parcelas implements IParcelas {
		nomeCondicaoPagamento: string = ''
		valorParcela: number = 0
		quantidadeParcela: number = 0
		texto: string = ''
		formaPagamento!: number
		idPagamento!: number
		colorTexto: string = 'black--text'
		codigoExterno: number | undefined
	}

	export interface IUpdateValores {
		formaPagamento: number
		fornecedor: number
		parcelas: number
		validacaoFormaPagamento: boolean
		validacaoParcelas: boolean
		valorSeguro: number
		codigoExterno: number
	}
}
